import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SetupDetail } from '../setup/detail/Detail';
import Loader from '../../Components/GlobalLoader/Loader';
import { CustomerProps, CustomerShipToListProps } from './model/customer.model';
import { getCustomerDetails, getcustomerShiptoList } from './service/customer.service';
import Table, { Column } from '../../Components/Tables/Table';


export default function CustomerDetails() {
  const pageName = "Customer Detail";
  const addUrl="/account/client/customer/add"
  const listUrl="/account/client/customer/list-view"
  const gridUrl="/account/client/customer/grid-view"
  const editUrl="/account/client/customer/edit";
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState<CustomerProps>();
  const [shipToCodeList, setShipToCodeList] = useState<CustomerShipToListProps[]>([]);
  const navigate = useNavigate();
  let payload :{
    columns: { data: string; as?: string }[];
    limit: number;
    search?: string;
    page?: number;
    perPage?: number;
    conditions?:any;
  } = {
    "columns": [
        {
            "data": "customer_ship_to.id"
        },
        {
            "data": "customer.id as customer_id"
        },
        {
            "data": "customer_ship_to.code"
        },
        {
            "data": "customer_ship_to.name"
        },
         {
            "data": "customer_ship_to.address_line_1"
        },
        {
            "data": "customer_ship_to.address_line_2"
        },
        {
            "data": "customer_ship_to.address_line_3"
        },
        {
            "data": "customer_ship_to.contact_phone"
        },
        {
            "data": "customer_ship_to.city"
        },
        {
            "data": "customer_ship_to.state_province"
        },
         {
            "data": "customer_ship_to.postal_code"
        },
         {
            "data": "customer_ship_to.state_province"
        },
        {
            "data": "customer_ship_to.country_code"
        }
    ],
    "limit": -1
};
  useEffect(() => {
      setLoading(true);
        if (id) {
          payload.conditions= [["customer.id", "=", id]];
          fetchCustomerData(id).then(async()=>{
            await getcustomerShiptoList(payload).then((data:any) => {
              setShipToCodeList(data.data.results);
         })
              setLoading(false);
          }).catch((error) => {
            setLoading(true);
            navigate("/404")
          });
        }
  }, [id])
  const fetchCustomerData = async (id: string): Promise<void> => {
    try {
      const response = await getCustomerDetails(id);
      if (response.data && response.status === 200) {
        setCustomer(response.data); 
      } else {
        throw new Error("Failed to fetch customer data");
      }
    } catch (error) {
      console.error("Failed to fetch customer data:", error);
      throw error; // Re-throw the error if you want the caller to handle it
    }
  };
  const columns = [
    { label: "Client", value: `${customer?.client?.name}(${customer?.client?.code})` },
    { label: "Customer Code", value: customer?.code },
    { label: "Customer Name", value: customer?.name },
    { label: "Address 1", value: customer?.address_line_1 },
    { label: "Address 2", value: customer?.address_line_2 },
    { label: "Address 3", value: customer?.address_line_3 },
    { label: "City", value: customer?.city },
    { label: "State/Province", value: customer?.state_province },
    { label: "Postal Code", value: customer?.postal_code },
    { label: "Country", value: customer?.country?.name },
    { label: "Contact Phone", value: customer?.contact_phone },
    { label: "Status", value: customer?.is_active ? "Active" : "Inactive" }
];
const shiptocolumns: Column[] = [
  {
    name: "Ship to Code",
    selector: (row: CustomerShipToListProps) => row.code,
  },
  {
    name: "Name",
    selector: (row: CustomerShipToListProps) => row.name,
  },
  {
    name: "Address 1",
    selector: (row: CustomerShipToListProps) => row.address_line_1,
  },
  {
    name: "Address 2",
    selector: (row: CustomerShipToListProps) => row.address_line_2,
  },
  {
    name: "Country",
    selector: (row: CustomerShipToListProps) => row.country,
  },
  {
    name: "State",
    selector: (row: CustomerShipToListProps) => row.state_province,
  },
  {
    name: "City",
    selector: (row: CustomerShipToListProps) => row.city,
  },
  {
    name: "Zip/Postal Code",
    selector: (row: CustomerShipToListProps) => row.postal_code,
  }

];
    return !loading ?(
      <>
      <SetupDetail
       pageName={pageName} 
       id={id??""}
       columns={columns}
       addUrl={addUrl}
       listUrl={listUrl}
       gridUrl={gridUrl}
       editUrl={editUrl}
       setupHeader={`Customer (${customer?.code})`}
      />
      <div className="d-flex justify-content-between align-item-center mb-3">
            <div>
              <h6 className="fw-bold">Ship to Code</h6>
            </div>
          </div>
      <div className="my-2 bg-white rounded py-1 px-4 customer-table-scroll">
        <Table
          columns={shiptocolumns}
          data={shipToCodeList ?? []}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      </>
    ):<Loader/>
}
